module.exports = "/static-assets/_next/static/images/plainRainbow-2628fec691cae6f6bc7a77be73eff789.png";